import { Key, Copy } from "lucide-react";
import { toast } from "sonner";

const DailyCodeTab = ({ dailyCode, dailyCountdown, dailyLoading, onGenerate }) => {
  return (
    <div className="max-w-lg">
      <h2 className="text-2xl font-['Oswald'] font-bold text-white mb-4">DAGENS ADGANGSKODE</h2>
      <p className="text-gray-400 mb-6">Generer en kode som nye medlemmer kan bruge til at logge ind. Koden er gyldig i 24 timer.</p>

      {dailyCode && dailyCode.active ? (
        <div className="mc-card p-6 border-green-500/30 mb-6" data-testid="daily-code-display">
          <div className="text-center">
            <p className="text-gray-400 text-sm mb-2">Aktiv dagskode:</p>
            <p className="text-5xl font-mono font-bold text-green-400 tracking-widest mb-3" data-testid="daily-code-value">{dailyCode.code}</p>
            <div className="flex items-center justify-center gap-3 mb-4">
              <button onClick={() => { navigator.clipboard.writeText(dailyCode.code); toast.success("Kopieret!"); }}
                className="flex items-center gap-2 px-4 py-2 rounded-lg bg-green-600/20 text-green-400 hover:bg-green-600/30 transition-colors"
                data-testid="copy-daily-code-btn">
                <Copy className="w-4 h-4" /> Kopier
              </button>
            </div>
            <p className="text-gray-400 text-sm">Udløber om <span className="text-white font-medium">{dailyCountdown}</span></p>
            {dailyCode.used_by && dailyCode.used_by.length > 0 && (
              <div className="mt-4 pt-4 border-t border-green-500/20">
                <p className="text-gray-500 text-xs mb-2">Brugt af:</p>
                <div className="flex flex-wrap gap-2 justify-center">
                  {dailyCode.used_by.map((u, i) => (
                    <span key={i} className="px-2 py-1 rounded bg-green-600/10 text-green-400 text-xs">{u.name}</span>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="mc-card p-8 text-center border-dashed border-gray-600 mb-6" data-testid="no-daily-code">
          <Key className="w-12 h-12 text-gray-500 mx-auto mb-4" />
          <p className="text-gray-400 mb-2">Ingen aktiv dagskode</p>
          <p className="text-gray-500 text-sm">Klik nedenfor for at generere en ny kode</p>
        </div>
      )}

      <button
        onClick={onGenerate}
        disabled={dailyLoading}
        className="w-full py-4 rounded-xl font-['Oswald'] uppercase tracking-wider bg-green-600 hover:bg-green-500 text-white disabled:opacity-50 transition-colors text-lg"
        data-testid="generate-daily-code-btn"
      >
        {dailyLoading ? "Opretter..." : dailyCode?.active ? "Generer ny dagskode" : "Opret dagskode"}
      </button>
      {dailyCode?.active && (
        <p className="text-yellow-400 text-xs text-center mt-3">Bemærk: Den nuværende kode deaktiveres når du opretter en ny</p>
      )}
    </div>
  );
};

export default DailyCodeTab;
